__turbopack_context__.v({
  "inherit": "V-P5Oa_inherit",
  "link": "V-P5Oa_link",
  "primary": "V-P5Oa_primary",
});
